var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ais-search-box',{staticClass:"w-full",attrs:{"placeholder":"Search IMPA Code or description","show-loading-indicator":true},on:{"focus":_vm.searching}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }